import axios from 'axios';

// Use VITE_API_URL if available (for production builds), otherwise use /api (for dev/proxy)
const baseURL = import.meta.env.VITE_API_URL || '/api';

const api = axios.create({
  baseURL,
  headers: {
    'Content-Type': 'application/json',
  },
  timeout: 60000, // 60 seconds timeout for delete operations
});

// Request interceptor to add JWT token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor to handle errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Check if this is an authentication error (invalid/expired token)
      // vs an authorization error from external API
      const requestUrl = error.config?.url || '';
      
      // Only redirect to login if:
      // 1. The error is from our own auth endpoints OR
      // 2. The error message indicates token issues
      const isAuthError = 
        requestUrl.includes('/auth/') || 
        error.response?.data?.error?.toLowerCase().includes('token') ||
        error.response?.data?.error?.toLowerCase().includes('authentication') ||
        error.response?.data?.message?.toLowerCase().includes('token') ||
        error.response?.data?.message?.toLowerCase().includes('authentication');
      
      // If it's likely an external API error (e.g., from auction API),
      // don't log out - just let the error propagate
      if (isAuthError) {
        localStorage.removeItem('token');
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

export default api;

